<script setup lang="ts">
    type Props = {
        count: number;
    };

    const props = defineProps<Props>();
</script>

<template>
    <span>
        <b-tag
            class="is-danger notification-count">
            {{ props.count }}
        </b-tag>
    </span>
</template>

<style scoped>
.notification-count {
    vertical-align: 2px;
    margin-left: 4px;
}
</style>
